class MainProduct extends HTMLElement {
  popularAddOns = [];

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
  }

  setPopularAddOns(data) {
    this.popularAddOns = data;
  }

  getPopularAddOns() {
    return this.popularAddOns;
  }

  handleAddOnAdded(item) {
    const addOns = this.getPopularAddOns();
    const index = addOns.findIndex((a) => a.id === item.id);
    if (index >= 0) {
      addOns[index] = item;
    } else {
      addOns.push(item);
    }
    this.setPopularAddOns(addOns);
    this.calculateTotalAddOnValue();
  }

  handleAddOnRemoved(item) {
    const addOns = this.getPopularAddOns().filter((addOn) => addOn.id !== item.id);
    this.setPopularAddOns(addOns);
    this.calculateTotalAddOnValue();
  }

  calculateTotalAddOnValue() {
    const addOns = this.getPopularAddOns();
    const totalPrice = addOns.reduce((total, item) => total + item.price, 0);
    const totalCompareAtPrice = addOns.reduce(
      (total, item) => total + (item.compareAtPrice || item.price),
      0
    );
    publish(`price:changed:product-add-ons:${this.sectionId}`, {
      priceInCents: totalPrice,
      compareAtPriceInCents: totalCompareAtPrice,
    });
  }
}

customElements.define('main-product', MainProduct);
